import { Box, Text, Skeleton } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";

function ResumoItem({
  description,
  icon,
  value,
  color = colors.primary,
  isLoading,
}: {
  description: string;
  icon: React.ReactChild;
  value: number;
  color?: string;
  isLoading?: boolean;
}) {
  return (
    <Box bg="white" borderRadius="2xl" shadow="lg">
      <Box bg={color} h="30px" w="100%" py="4px" borderTopRadius="2xl">
        <Box
          d="flex"
          alignItems="center"
          justifyContent="center"
          color="#FFFFFF"
          gap="8px"
        >
          {!isLoading ? icon : null}
          <Text fontSize="16px" bottom="-1px" pos="relative">
            {!isLoading ? value || "nenhum" : null}
            {isLoading ? <Skeleton m="auto" h="20px" w="65px" /> : null}
          </Text>
        </Box>
      </Box>
      <Box
        textAlign="center"
        w="100%"
        h="90px"
        display="flex"
        alignItems="center"
        px="8px"
        mx="auto"
      >
        <Box w="100%" textAlign="center">
          {!isLoading ? description : null}
          {isLoading ? <Skeleton m="auto" h="45px" w="60%" /> : null}
        </Box>
      </Box>
    </Box>
  );
}

export default ResumoItem;
